import { Box, InputLabel, Switch } from '@mui/material';
import { styled } from '@mui/material/styles';

import styles from './Switch.module.scss';

const { whiteColor, checkedColor } = styles;

interface ISwitchProps {
	label: string;
	value: boolean;
	onChange: any;
	isDisabled?: boolean;
}

const MaterialUISwitch = styled(Switch)(() => ({
	width: 60,
	height: 34,
	padding: 7,
	'& .MuiSwitch-switchBase': {
		margin: 1,
		marginLeft: 2,
		padding: 0,
		transform: 'translateX(6px)',
		'&.Mui-checked': {
			color: whiteColor,
			transform: 'translateX(30px)',
		},
		'&.Mui-checked + .MuiSwitch-track': {
			backgroundColor: checkedColor,
			opacity: 2,
		},
	},
	'& .MuiSwitch-thumb': {
		width: 17,
		height: 17,
		marginTop: 7.5,
		marginLeft: 1,
	},
	'& .MuiSwitch-track': {
		borderRadius: 20 / 2,
	},
	'&.Mui-disabled': {
		cursor: 'not-allowed',
	},
}));

const SwitchComp = (props: ISwitchProps) => {
	const { label, onChange, value, isDisabled } = props;

	return (
		<Box sx={{ display: 'flex' }}>
			<InputLabel className={styles['switch-label']}>{label}</InputLabel>
			<MaterialUISwitch
				onChange={onChange}
				checked={value}
				disabled={isDisabled}
			/>
		</Box>
	);
};

export default SwitchComp;
